import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { tasksId } from '../../../types/activityTasks';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';


const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	dialogEight: 9,
	dialogNine: 10,
	dialogTen: 11,
	dialogEleven: 12,
	dialogTwelve: 13,
	dialogThirteen: 14,
	dialogFourteen: 15,
	dialogFifteen: 16,
	dialogSixteen: 17,
	dialogSeventeen: 18,
	dialogEighteen: 19,
};

const stepThree = {
	move_koxka: steps.dialogTwo,
	remove_product_1: steps.dialogThree,
	clean_product_1: steps.dialogFour,
	remove_product_2: steps.dialogFive,
	place_product_1: steps.dialogSix,
	remove_product_all: steps.dialogEight,
	detect_holes: steps.dialogNine,
	move_product_up: steps.dialogTen,
	remove_slits: steps.dialogEleven,
	clean_cracks: steps.dialogTwelve,
	clean_all: steps.dialogThirteen,
	add_slits: steps.dialogFourteen,
	go_back_init: steps.dialogFifteen,
}

const stepThreeAudio = {
	move_koxka: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a02T3)
		}
	},
	remove_product_1: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a03T3)
		}
	},
	clean_product_1: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a04T3)
		}
	},
	remove_product_2: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a05T3)
		}
	},
	place_product_1: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a06T3)
		}
	},
	remove_product_all: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a08T3)
		}
	},
	detect_holes: {
		action: () => {

		}
	},
	move_product_up: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a10T3)
		}
	},
	remove_slits: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a11T3)
		}
	},
	clean_cracks: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a12T3)
		}
	},
	clean_all: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a13T3)
		}
	},
	add_slits: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a14T3)
		}
	},
	go_back_init: {
		action: () => {
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a15T3)
		}
	},
}


export const Theme3SubtopicTwoActivityFive = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema2], 5);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 2 act 5");
			ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 5);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic2.actFive.finishMoveactCleanKoaxka, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

		const stepAudio = stepThreeAudio[step]
		stepAudio.action()
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic2.initScene, 5);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 1: Ejecución de koxka y salchikoxka" />
					<DialogBarNew
						dialog={`Continúa para conocer los pasos de limpieza interna del Koxka.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 2: Máquina Warmer y Koxka y Salchikoxka"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "move_koxka")
							setUiToShow(-1);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`Retira los productos de la repisa superior y toma una canastilla limpia, libre de materia extraña/plaga, para colocar el producto en ella. Resguarda la canastilla en el Cuarto Frio, cuidando que no quede directamente en el piso.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "remove_product_1")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Limpia con el trapo azul húmedo y el líquido multiusos, todas las charolas porta productos, paredes interiores y la repisa completa hasta eliminar cualquier mancha, polvo o residuo de comida. Seca con el papel secante.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "clean_product_1")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Repite los pasos 1 y 2 para el resto de las repisas, ahora colocando los productos en las repisas inferiores, o en las que ya hayan sido limpiadas.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "remove_product_2")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Vuelve a colocar las charolas y los productos de acuerdo al planograma. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "place_product_1")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Cada tres días deberás realizar la limpieza del canal de residuos y rejillas. Los pasos son los siguientes:`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a07T3)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Paso 1: Retira los productos y colócalos en las repisas superiores, si están muy llenas, llévalos al Cuarto Frío.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "remove_product_all")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEight && (
				<>
					<DialogBarNew
						dialog={`Paso 2: Ubica los dos agujeros que se encuentran en la base de la repisa, en caso de no tener dichos agujeros continúa con el paso 4 (canal tipo 2).`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a09T3)
							setUiToShow(steps.dialogNine);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogNine && (
				<>
					<DialogBarNew
						dialog={`Paso 3: Introduce tus dedos índice en los agujeros y jala hacia arriba para retirar la repisa.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "move_product_up")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTen && (
				<>
					<DialogBarNew
						dialog={`Paso 4: Retira la rejilla de respiración y desengancha el canal de residuos.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "remove_slits")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEleven && (
				<>
					<DialogBarNew
						dialog={`Paso 5: Limpia con el trapo azul húmedo y el líquido multiusos el canal hasta eliminar toda la basura, residuos de comida, insectos, manchas y polvo. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "clean_cracks")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogTwelve && (
				<>
					<DialogBarNew
						dialog={`Paso 6: Enjuaga con el trapo azul húmedo y seca con papel secante. No es necesario que limpies el desagüe, el responsable de mantenimiento del equipo de tu Plaza lo hará periódicamente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "clean_all")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThirteen && (
				<>
					<DialogBarNew
						dialog={`Paso 7: Coloca nuevamente en este orden el canal de residuos, la rejilla de respiración y la base de la repisa. Vuelve a colocar las charolas y los productos de acuerdo al planograma.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "add_slits")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFourteen && (
				<>
					<DialogBarNew
						dialog={`IMPORTANTE Mantén alejadas tus manos de los ventiladores para evitar sufrir lesiones. `}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka, "go_back_init")
							setUiToShow(-1);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFifteen && (
				<>
					<DialogBarNew
						dialog={`En el canal tipo 3 no aplica el retiro de la rejilla ya que está sujetada con remaches. El prestador de servicio de tu Plaza realizará la tarea de limpieza.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a16T3)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka)
							setUiToShow(steps.dialogSixteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSixteen && (
				<>
					<DialogBarNew
						dialog={`Por último, pero no menos importante, limpia con el trapo azul húmedo y el líquido multiusos las paredes externas, la base y la superficie de la canastilla de frescos. Enjuaga con el trapo azul húmedo y seca con el papel secante.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_2.sub2_act5_a17T3)
							setUiToShow(steps.dialogEighteen);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogEighteen && (
				<>
					<DialogBarNew
						dialog={`Esta es la manera en la que mantienes el Koxka y el Salchikoxka en óptimas condiciones. Tus tareas serán marcadas como realizadas ¡buen trabajo!`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.tema3.topic2.actFive.actCleanKoaxka)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}


			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda que cada tres días deberás realizar la limpieza del canal de residuos y rejillas."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 5,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema2
								})
							);
							navigator("/home3/tema3/subtema2/activityresult");
						}}
					/>
				</>
			)}

		</>
	)
}
